import { gql } from "graphql-request";

const GetItemsBusinessQuery = gql`
  query GetItemsBusiness($companyId: Int!, $businessId: Int!) {
    GetItemsBusiness(companyId: $companyId, businessId: $businessId) {
      id
      code
      editable
      activity
      description
      comment
      universal
      ItemVersions {
        id
        title
        type
        informative
        taxable
        tributable
        extraHours
        gratification
        compensation
        holidays
        medicalLicenses
        ineCode
        calculationOrder
        printOrder
        printOnSalarySettlement
        isRetained
        seizable
        proportional
        isFixed
        capped
        cappedValue
        accountingInformative
        printDescription
        descriptionToPrint
        analyticAccounting
        accountingCodeId
        print
        subjectToCompensation
        ItemId
        version
        lreCode
        DefaultFormulaId
        distributableInCC
        ledgerAccount
        Formulas {
          code
        }
      }
      ItemBusinesses {
        id
        BusinessId
      }
    }
  }
`;
export default GetItemsBusinessQuery;
